export interface TabsADC {
  text: string;
  className: string;
  iconCls: string;
  tabName: string;
}
